<template>
  <layout title="Classrooms">
    <div
      v-if="teaching_classrooms.data.length && learning_classrooms.data.length"
      class="row mb-4"
    >
      <div class="col-10">
        <h2 class="page-heading">Teach</h2>
      </div>
      <div class="col-2"></div>
    </div>

    <div v-if="teaching_classrooms.data.length" class="row">
      <div
        class="col-sm-4 mb-3"
        v-for="teaching_classroom in teaching_classrooms.data"
        :key="teaching_classroom.id"
      >
        <div class="card shadow shadow-sm">
          <div class="card-body">
            <div class="float-right">
              <img src="/images/group.svg" />
              &nbsp;
              <span class="align-middle">
                {{ teaching_classroom.students_count }}
              </span>
            </div>

            <h4 class="card-title">{{ teaching_classroom.name }}</h4>
            <hr/>
            <small>Course: {{ teaching_classroom.course.name }}</small>
            <br/>
            <br/>
            <p class="card-text">
              {{ teaching_classroom.description || '&nbsp;' }}
            </p>
            <inertia-link :href="route('classrooms.assigned.view.overview', teaching_classroom.id)" class="float-right btn btn-sm btn-outline-primary">
              Go to classroom
            </inertia-link>
          </div>
        </div>
      </div>
    </div>

    <div v-if="learning_classrooms.data.length" class="row mb-4">
      <div class="col-10">
        <h2 class="page-heading">Learn</h2>
      </div>
      <div class="col-2"></div>
    </div>

    <div v-if="learning_classrooms.data.length" class="row">
      <div
        class="col-sm-4 mb-3"
        v-for="learning_classroom in learning_classrooms.data"
        :key="learning_classroom.id"
      >
        <div class="card shadow shadow-sm">
          <div class="card-body">
            <div class="float-right">
              <img src="/images/group.svg" />
              &nbsp;
              <span class="align-middle">
                {{ learning_classroom.students_count }}
              </span>
            </div>

            <h4 class="card-title">{{ learning_classroom.name }}</h4>
            <hr/>
            <small>Course: {{ learning_classroom.course.name }}</small>
            <br/>
            <br/>
            <p class="card-text">
              {{ learning_classroom.description || '&nbsp;' }}
            </p>
            <inertia-link :href="route('classrooms.assigned.view.overview', learning_classroom.id)" class="float-right btn btn-sm btn-outline-primary">
              Go to classroom
            </inertia-link>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        !teaching_classrooms.data.length && !learning_classrooms.data.length
      "
      class="row mb-4"
    >
      <div class="card col-md-12 shadow-sm p-3 mb-5 bg-white rounded mt-2">
        <div class="card-body">
          <h3>You're not assigned to any classrooms.</h3>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    teaching_classrooms: Object,
    learning_classrooms: Object,
    flash: Object,
  },
  data() {},
  methods: {},
};
</script>